<header class="flex h-16 shrink-0 items-center gap-2 bg-topbar px-3 sm:gap-4 sm:px-6">
  <!-- Abre el cajón del menú; desde `lg` el menú es fijo y este botón sobra -->
  <button
    type="button"
    (click)="layout.abrirSidebarMovil()"
    class="flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-full text-white/70 transition-colors hover:bg-white/10 hover:text-white lg:hidden"
    aria-label="Abrir menú"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
      <path d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  </button>

  <!-- Regional del usuario: todo lo que ve y crea queda dentro de ella -->
  <div class="flex min-w-0 flex-1 items-center">
    @if (regional(); as regional) {
      <div
        class="flex min-w-0 items-center gap-2 rounded-full bg-white/10 py-1.5 pl-2.5 pr-3 text-white"
        [title]="veTodas() ? regional.nombre + ' · con acceso a todas las regionales' : regional.nombre"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4 shrink-0 text-white/70">
          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
        <span class="truncate text-xs font-semibold sm:text-sm">{{ regional.nombre }}</span>
        @if (veTodas()) {
          <span class="hidden shrink-0 rounded-full bg-white/15 px-2 py-0.5 text-[10px] font-semibold tracking-wide uppercase md:inline">
            Ve todas
          </span>
        }
      </div>
    }
  </div>

  <!-- Acciones -->
  <div class="flex items-center gap-2">
    <!-- Modo claro / oscuro -->
    <button
      type="button"
      (click)="theme.toggle()"
      class="flex size-9 cursor-pointer items-center justify-center rounded-full text-white/70 transition-colors hover:bg-white/10 hover:text-white"
      [attr.aria-label]="theme.dark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
    >
      @if (theme.dark()) {
        <!-- Sol -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
        </svg>
      } @else {
        <!-- Luna -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
          <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
        </svg>
      }
    </button>

    <!-- Usuario: abre el perfil (info de SIGERH + firma) -->
    <button
      type="button"
      (click)="layout.perfilAbierto.set(true)"
      class="ml-1 flex cursor-pointer items-center gap-3 rounded-full py-1 pl-1 pr-3 text-left transition-colors hover:bg-white/10"
      title="Ver perfil"
    >
      <div class="flex size-9 items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-white">
        {{ iniciales() }}
      </div>
      <div class="hidden leading-tight sm:block">
        <p class="text-sm font-semibold text-white">{{ nombre() }}</p>
        <p class="max-w-44 truncate text-xs text-white/50">{{ rol() }}</p>
      </div>
    </button>

    <!-- Cerrar sesión -->
    <button
      type="button"
      (click)="cerrarSesion()"
      class="ml-1 flex size-9 cursor-pointer items-center justify-center rounded-full text-white/70 transition-colors hover:bg-white/10 hover:text-white"
      aria-label="Cerrar sesión"
      title="Cerrar sesión"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <path d="m16 17 5-5-5-5" />
        <path d="M21 12H9" />
      </svg>
    </button>
  </div>
</header>
